/**
 * Looks for ancestor elemnt with given selector
 * @param {HTMLElement} elem the elemnt to test
 * @param {string} selector the selector you're looking for
 * @returns {HTMLElement} element The closest element
 */
const closest = (elem, selector) => {
  let element = elem;
  const matchesSelector =
    element.matches ||
    element.webkitMatchesSelector ||
    element.mozMatchesSelector ||
    element.msMatchesSelector;
  while (element) {
    if (matchesSelector.call(element, selector)) {
      break;
    }
    element = element.parentElement;
  }
  return element;
};

export default closest;
